export const getReviewHistoryContainerStyle = (theme) => ({
    width: 'fit-content',
    margin: '.5rem auto 1rem',
    padding: '.5rem .75rem',
    borderRadius: '.25rem',
    backgroundColor: theme.buttonColor,
});
